'use client';

import { useState } from 'react';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import LinkAccordian from '@alltrails/seo/components/LinkAccordian';
import DesktopLinkSection from './DesktopLinkSection';
import styles from './SeoLinks.module.scss';

export type LinkSectionProps = {
  isMobileExpanded?: boolean;
  links: { label: string; href: string }[];
  seoTestAddHikingTrailsToLocationLinks?: boolean;
  seoTestAddTrailsToLocationLinks?: boolean;
  title: string;
};

const LinkSection = ({
  links,
  title,
  isMobileExpanded = false,
  seoTestAddTrailsToLocationLinks,
  seoTestAddHikingTrailsToLocationLinks
}: LinkSectionProps) => {
  const [isOpen, setIsOpen] = useState(isMobileExpanded);
  const isMobile = useIsMobileSizedScreen();

  return isMobile ? (
    <LinkAccordian title={title} isOpen={isOpen} toggleIsOpen={() => setIsOpen(!isOpen)} links={links} />
  ) : (
    <div className={styles.desktopLinkSection}>
      <DesktopLinkSection
        title={title}
        links={links}
        seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
        seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
      />
    </div>
  );
};

export default LinkSection;
